declare global {
    interface Window {
        ym?: (id: number, method: string, goal: string, params?: any) => void;
    }
}

export const callYaMetrika = (goal: string, params: any = null) => {
    if (typeof window !== 'undefined' && window.ym) {
        try {
            console.log(`reachGoal ${goal}`);
            if (params)
                window.ym(101796152, 'reachGoal', goal, params);
            else
                window.ym(101796152, 'reachGoal', goal);
        } catch (e) {
            console.error('Yandex Metrika error:', e);
        }
    } else {
        console.log(`local reachGoal ${goal}`);
    }
};
